import React from "react"
import "./new-product-info.scss"
import { siteUrl } from "../../../shared/utils/siteUrl"

const NewProductInfo = ({haveTrackSample}) => {
  return (
    <div className="f-new-product-info">
      <div className="f-new-product-info__wrapper">
        <p className="f-new-product-info__name">
          Nueva Nosotras V-Confident
          <span> para tu etapa adulta. </span>
        </p>
        <a className="f-new-product-info__link" href={siteUrl + "/v-confident"} target="_blank" rel="noreferrer" >
          {haveTrackSample ? (
            <>
              ¡Pide tu muestra gratis aquí!
            </>
          ) : (
            <>
              ¡Conoce más aquí!
            </>

          )}
        </a>
      </div>
    </div>
  )
}

export default NewProductInfo
